import OapUsage from './code/Scripts/components/OapUsage.vue';

export default {
  components: {
    OapUsage,
  },
};
